const fileFor = (name) => `/brands-color/${name.toLowerCase().replace(/\s+/g, "-")}.png`;

export const BrandMark = ({ brand, className = "h-8 w-8" }) => (
  <span className={`inline-flex items-center justify-center ${className}`}>
    <img src={fileFor(brand.name)} alt={`${brand.name} logo`} loading="lazy" className="max-h-full max-w-full object-contain" />
  </span>
);
